import {
  Button,
  Container,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
} from "@mui/joy";
import { Stack } from "@mui/material";
import * as React from "react";
import { useLocation, useNavigate } from "react-router";
import HeaderBackButton from "../components/HeaderBackButton";
import { convert, CurrencyFormat } from "../config/services";

export default function Send() {
  const navigate = useNavigate();
  let { state } = useLocation();
  const { image, code, balance, price } = state;
  const [data, setData] = React.useState({
    amount: 0,
    coin: 0,
    address: "",
    network: "Bitcoin",
  });

  const handleChangeCoin = async (value, key) => {
    await convert.ready();
    switch (key) {
      case "BTC":
        return convert.BTC.USD(value);
      case "ETH":
        return convert.ETH.USD(value);
      case "BNB":
        return convert.BNB.USD(value);
      case "TRX":
        return convert.TRX.USD(value);
      case "POLY":
        return price * value;
      case "SOL":
        return convert.SOL.USD(value);
      case "ARB":
        return convert.ARB.USD(value);
      case "AVAX":
        return convert.AVAX.USD(value);
      case "XRP":
        return convert.XRP.USD(value);
      case "DOGE":
        return convert.DOGE.USD(value);
      default:
        return convert.USDT.USDT(value);
    }
  };

  const handleChangeCoinMax = async (value, key) => {
    await convert.ready();
    switch (key) {
      case "BTC":
        return convert.USD.BTC(value);
      case "XRP":
        return convert.USD.XRP(value);
      case "DOGE":
        return convert.USD.DOGE(value);
      case "ETH":
        return convert.USD.ETH(value);
      case "BNB":
        return convert.USD.BNB(value);
      case "TRX":
        return convert.USD.TRX(value);
      case "POLY":
        return value / price;
      case "SOL":
        return convert.USD.SOL(value);
      case "ARB":
        return convert.USD.ARB(value);
      case "AVAX":
        return convert.USD.AVAX(value);
      default:
        return convert.USDT.USDT(value);
    }
  };

  const handleChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const setCurrency = (event, amount) => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
      amount: amount,
    });
  };

  const pasteAddress = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setData({ ...data, address: text });
    } catch (error) {
      console.error("Failed to read clipboard contents: ", error);
    }
  };

  const setMaxAmount = () => {
    if (balance > 0) {
      handleChangeCoinMax(balance, code).then((vl) => {
        setData({ ...data, coin: vl, amount: balance });
      });
    }
  };

  return (
    <>
      <HeaderBackButton title={`Send ${code}`} />

      <Container maxWidth="sm">
        <Stack spacing={6} mt={4}>
          <FormControl>
            <FormLabel>Receiver {code} address</FormLabel>
            <Input
              size="lg"
              sx={{ "--Input-decoratorChildHeight": "45px" }}
              name="address"
              placeholder="Address"
              type="text"
              required
              value={data.address}
              onChange={handleChange}
              error={data.status === "failure"}
              endDecorator={
                <Button
                  variant="soft"
                  color="neutral"
                  type="submit"
                  sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                  onClick={pasteAddress}
                >
                  Paste
                </Button>
              }
            />
          </FormControl>

          <FormControl>
            <FormLabel>{code} amount</FormLabel>
            <Input
              name="coin"
              size="lg"
              sx={{ "--Input-decoratorChildHeight": "45px" }}
              placeholder="0.00"
              type="number"
              required
              value={data.coin}
              onChange={(event) => {
                handleChange(event);
                if (event.target.value > 0) {
                  handleChangeCoin(event.target.value, code).then((amount) =>
                    setCurrency(event, amount)
                  );
                }
              }}
              error={data.status === "failure"}
              endDecorator={
                <Button
                  variant="solid"
                  color="primary"
                  loading={data.status === "loading"}
                  type="submit"
                  sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                  onClick={setMaxAmount}
                >
                  Max
                </Button>
              }
            />
            <FormHelperText>
              Receiver gets{" "}
              <CurrencyFormat
                amount={data.amount}
                prefix={"$"}
                seperator={true}
              />
            </FormHelperText>
          </FormControl>

          <Button
            variant="solid"
            color="primary"
            fullWidth
            size="lg"
            disabled={
              balance < data.amount || balance == 0 || data.amount < 100000
            }
            onClick={() =>
              navigate("/passcode", {
                state: {
                  coin: state,
                  data: data,
                },
              })
            }
          >
            Continue
          </Button>
        </Stack>
      </Container>
    </>
  );
}
